import { useCallback } from "react";
import { useVersionCheckContext } from "../contexts/VersionCheckContext";

/**
 * Hook that provides version check utilities.
 * - Periodic checks (every 5 mins) only show the update banner
 * - Force refresh only happens when user navigates to a new route
 */
export const useVersionCheck = () => {
  const { checkForUpdate, hasUpdate, navigateWithCheck } = useVersionCheckContext();

  return { checkForUpdate, hasUpdate, navigateWithCheck };
};

/**
 * Hook to intercept link clicks and check for updates before navigation.
 * Use this in components that handle navigation.
 */
export const useNavigationWithVersionCheck = () => {
  const { checkForUpdate, refreshApp } = useVersionCheckContext();

  const navigateWithCheck = useCallback(
    async (navigateFn: () => void, targetPath: string) => {
      const hasUpdate = await checkForUpdate();

      if (hasUpdate) {
        // Store the target path and refresh
        sessionStorage.setItem("post-update-redirect", targetPath);
        refreshApp();
      } else {
        // No update, proceed with normal navigation
        navigateFn();
      }
    },
    [checkForUpdate, refreshApp]
  );

  return { navigateWithCheck };
};
